import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs";
import { ModalService } from "@core-services/modal.service";
import { OnfidoService } from "../../services/onfido.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
	selector: "verification-onfido-content",
	templateUrl: "./verification-onfido-content.component.html",
	styleUrls: ["./verification-onfido-content.component.scss"],
	standalone: false
})
export class VerificationOnfidoContentComponent implements OnInit, AfterViewInit {
	@Input() public logoUrl: string = "";
	@Input() public language: string = "";
	@Input() public document: string = "";

	@Output() public modalTitle: EventEmitter<string> = new EventEmitter<string>();
	@Output() public onTermsAccept: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public closeAllModals: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Input() public onParentBack: Observable<void>;

	// Terms and permissions
	private termsAccepted: boolean = false;

	private isBrowserCompatible: boolean = true;
	private incompatibilityType: string = "";

	private verificationProgress: number = 2;

	public constructor(
		private modalService: ModalService,
		private onfidoService: OnfidoService
	) {}

	public ngOnInit(): void {
		this.modalTitle.emit("eid_data_modal_title");
		this.onParentBack.pipe(untilDestroyed(this)).subscribe(() => this.onClickBack());
		this.setTermsAccepted(false);
	}

	public ngAfterViewInit(): void {
		this.verificationProgress = 3;
	}

	public getVerificationProgress(): number {
		return this.verificationProgress;
	}

	public onTermsContinueClick(): void {
		this.modalTitle.emit("verification_permission_modal_title");
		this.setTermsAccepted(true);

		// Check compatibility and start Onfido flow
		this.checkBrowserCompatibility();
	}

	public isFirstStep(): boolean {
		return !this.hasAcceptedTerms();
	}

	public isSecondStep(): boolean {
		return !this.isFirstStep() && !this.isBrowserCompatible;
	}

	public hasAcceptedTerms(): boolean {
		return this.termsAccepted;
	}

	private onClickBack(): void {
		if (this.hasAcceptedTerms()) {
			this.setTermsAccepted(false); // Go back one step (from Camera permissions to Terms)
			this.modalTitle.emit("eid_data_modal_title");
		}
	}

	private setTermsAccepted(value: boolean): void {
		this.termsAccepted = value;
		this.onTermsAccept.emit(value);
	}

	public getIncompatibilityType(): string {
		return this.incompatibilityType;
	}

	private checkBrowserCompatibility(): void {
		this.isBrowserCompatible = OnfidoService.hasFullSupport();

		if (this.isBrowserCompatible) {
			// Announce parent to close all popups (dismiss)
			this.closeAllModals.emit();
			// Start Onfido flow
			this.onfidoService.preselectLanguage(this.language);
			this.onfidoService.initOnfido(this.document);
		} else {
			this.incompatibilityType = OnfidoService.getIncompatibilityType();
			this.modalTitle.emit("verification_browser_modal_title");
		}
	}
}
